import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { getShopsRequest } from "../../../Shop/slices/shopActions";
import { ReportFiltersProvider } from "../../contexts/ReportFiltersContext";
import ReportsHeader from "../../components/ReportsHeader";
import ReportsSidebar from "../../components/ReportsSidebar";
import MobileSidebarDrawer from "../../components/MobileSidebarDrawer";
import PipelineStagesManager from "../../../Chat/components/PipelineStagesManager";

const ReportsLayout = () => {
  const dispatch = useDispatch();
  const shops = useSelector((state) => state.shops);
  const auth = useSelector((state) => state.auth);
  const defaultShopId = shops?.data?.[0]?._id || null;
  const accountId = auth?.user?.accountId;

  const [mobileOpen, setMobileOpen] = useState(false);
  const [stagesManagerOpen, setStagesManagerOpen] = useState(false);
  // Bumped whenever stages change — pipeline report hook watches this.
  const [stagesVersion, setStagesVersion] = useState(0);
  const stagesVersionRef = useRef(stagesVersion);
  stagesVersionRef.current = stagesVersion;

  useEffect(() => {
    const staffId = auth?.user?.id;
    if (accountId && staffId && (!shops?.data || shops.data.length === 0)) {
      dispatch(getShopsRequest({ accountId, staffId }));
    }
  }, [dispatch, accountId, auth?.user?.id, shops?.data?.length]);

  const openStagesManager = useCallback(() => setStagesManagerOpen(true), []);
  const closeStagesManager = useCallback(() => setStagesManagerOpen(false), []);
  const handleStagesChanged = useCallback(() => {
    setStagesVersion((v) => v + 1);
  }, []);

  return (
    <ReportFiltersProvider defaultShopId={defaultShopId}>
      <div className="flex flex-col h-full min-h-0 bg-gray-50">
        <ReportsHeader onToggleSidebar={() => setMobileOpen(true)} />
        <div className="flex flex-1 min-h-0">
          <div className="hidden md:block">
            <ReportsSidebar />
          </div>
          <main className="flex-1 overflow-auto">
            <Outlet
              context={{
                openStagesManager,
                stagesVersion,
              }}
            />
          </main>
        </div>

        <MobileSidebarDrawer
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
        >
          <ReportsSidebar onNavigate={() => setMobileOpen(false)} />
        </MobileSidebarDrawer>

        <PipelineStagesManager
          isOpen={stagesManagerOpen}
          onClose={closeStagesManager}
          accountId={accountId}
          onChanged={handleStagesChanged}
        />
      </div>
    </ReportFiltersProvider>
  );
};

export default ReportsLayout;
